import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardHeader } from '@achra/ui/card';
import { Skeleton } from '@achra/ui/skeleton';
import { SelectedFacetsSkeleton } from './selected-facets-skeleton';
import { SummarySectionSkeleton } from './summary-section-skeleton';
function SummaryCardSkeleton() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="size-12 shrink-0 rounded-2xl" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-start gap-2">{t0}<div className="flex flex-col gap-1"><Skeleton className="h-5 w-full max-w-48 lg:h-6" /><Skeleton className="h-3.5 w-full max-w-28" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CardHeader className="flex flex-row items-center justify-between gap-4 px-3 pt-3 lg:px-6 lg:pt-6">{t1}<div className="flex shrink-0 flex-col items-end gap-0.5"><div className="flex flex-col items-end"><Skeleton className="h-5 w-16" /><Skeleton className="h-3.5 w-20" /></div><Skeleton className="h-3.5 w-24" /></div></CardHeader>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SelectedFacetsSkeleton />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Card className="mx-auto w-full max-w-218.5 overflow-hidden border-none p-0! lg:mx-0 lg:max-w-none">{t2}<CardContent className="flex flex-col gap-6 p-0! pb-3! lg:pb-6!">{t3}<div className="flex flex-col gap-4 px-3 lg:px-6"><SummarySectionSkeleton hasTotal={true} /><SummarySectionSkeleton /></div></CardContent></Card>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export { SummaryCardSkeleton };